import { SectionBasic } from '@sbercloud/uikit-product-site-section';

import { useLayoutType } from '../../hooks/useLayoutType';
import s from './About.module.scss';
import { AboutProps } from './types';

export function About({
  id,
  title,
  description,
  footnote,
  className = '',
}: AboutProps) {
  const layoutType = useLayoutType();

  return (
    <SectionBasic
      id={id}
      layoutType={layoutType}
      className={className}
      title={title}
      description={description}
    >
      {footnote && (
        <div
          className={s.footnote}
          dangerouslySetInnerHTML={{ __html: footnote }}
        />
      )}
    </SectionBasic>
  );
}
